<template>
  <section class="section-content">
    <p>
      Fill in the URI of the resource you want to create/edit.
    </p>
    <p>
      <a href="#!create" class="btn">Create resource...</a>
    </p>
  </section>
</template>

<script>
export default {
  name: 'home'
}
</script>



// WEBPACK FOOTER //
// Home.vue?938534b6